// extracted by mini-css-extract-plugin
module.exports = {"link":"ApproveRejectNotificationMessage_link__13Fb5"};